import { Box, useTheme } from "@mui/material";
import { buildCDNURL } from "@platformx/utilities";
import HiddenTextBox from "../HiddenTextBox/HiddenTextBox";

const IconPicker = ({
  field,
  state,
  setState,
  errors,
  register,
  clearErrors,
  isDisabled = false,
}: any) => {
  const theme = useTheme();
  const selectedIcon = state[field?.name] || "";

  const handleIconClick = (icon: string) => {
    if (isDisabled) return;
    clearErrors(field?.name);
    setState({
      ...state,
      [field?.name]: selectedIcon === icon ? "" : icon,
    });
  };

  return (
    <Box id={`${field?.name}_id`}>
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
        {(field?.options || []).map((icon) => {
          const relativeUrl = buildCDNURL(icon);

          return (
            <Box
              className='menuIconsBox'
              key={icon}
              onClick={() => handleIconClick(icon)}
              data-testid='icon-picker-item'
              sx={{
                width: "38px",
                height: "38px",
                objectFit: "cover",
                cursor: isDisabled ? "not-allowed" : "pointer",
                opacity: isDisabled ? 0.6 : 1,
                margin: "0 20px 20px 0",
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: theme.borderRadius?.value,
                backgroundColor:
                  selectedIcon === icon
                    ? theme.palette.customColor.TERTIARY
                    : theme.palette.customColor.LIGHT,
                "& img": {
                  filter: selectedIcon === icon ? "brightness(100)" : "",
                },
              }}>
              <picture>
                <source srcSet={relativeUrl} type='image/avif' />
                <img src={relativeUrl} alt='icon' style={{ width: "24px", height: "24px" }} />
              </picture>
            </Box>
          );
        })}
      </Box>
      <HiddenTextBox
        error={errors?.[field?.name]}
        value={selectedIcon}
        register={register}
        name={field?.name}
        required={
          field?.validations?.[0]?.type === "required" && !selectedIcon
            ? field?.validations[0]?.message
            : ""
        }
      />
    </Box>
  );
};

export default IconPicker;
